module.exports = __webpack_public_path__ + "img/FR44729.383b29f0.png";